import React, { useEffect, useState, useRef } from 'react'
import styles from './SliderBlockContent.module.scss'
import classNames from 'classnames'
import {findIndex} from 'lodash'
import { MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight  } from "react-icons/md";
import { FaPlay, FaVideo } from 'react-icons/fa';

export function getYoutubeId(url) {
  if (!url) return null;
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  const match = url.match(regExp);
  return (match && match[2].length === 11) ? match[2] : null;
}

export function getVimeoId(url) {
  if (!url) return null;
  const regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/)|(video\/))?([0-9]+)\/?.*/;
  const match = url.match(regExp);
  return match ? match[6] : null;
}

function SliderBlockContent({items =[], activeItem}) {
  const [active, setActive] = useState(items[0] ? items[0] : {})
  const activeThumbRef = useRef(null)
  const containerRef = useRef(null)

  useEffect(() => {
    if(activeItem){
      setActive(activeItem)
    } else {
      setActive(items[0] ? items[0] : {})
    }
  }, [activeItem, items])

  const indexFind = findIndex(items, ['id', active.id])

  useEffect(() => {
    // Scroll active thumbnail into view
    if (activeThumbRef.current && containerRef.current) {
      const container = containerRef.current;
      const thumb = activeThumbRef.current;
      
      const scrollLeft = thumb.offsetLeft - (container.offsetWidth / 2) + (thumb.offsetWidth / 2);
      container.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
      });
    }
  }, [indexFind]);

  const nextSlide = items[indexFind + 1]
  const prevSlide = items[indexFind - 1]

  const renderSlideContent = (_i, index) => {
    if (_i.type === 'video') {
      const youtubeId = getYoutubeId(_i.src);
      const vimeoId = getVimeoId(_i.src);

      if (youtubeId) {
        return (
          <iframe
            width="100%"
            height="100%"
            src={`https://www.youtube.com/embed/${youtubeId}`}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title={`Slide ${index + 1}`}
            style={{ border: 'none', width: '100%', height: '100%' }}
          />
        );
      } else if (vimeoId) {
        return (
          <iframe
            width="100%"
            height="100%"
            src={`https://player.vimeo.com/video/${vimeoId}`}
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            title={`Slide ${index + 1}`}
            style={{ border: 'none', width: '100%', height: '100%' }}
          />
        );
      } else {
        return (
          <video
            src={_i.src}
            controls
            preload="metadata"
            style={{ width: '100%', height: '100%', objectFit: 'contain', backgroundColor: '#000' }}
          />
        );
      }
    }

    // Default to image
    return <img src={_i.src} alt={`Slide ${index + 1}`} />;
  };

  const renderThumbnailContent = (item, index) => {
    if (item.type === 'video') {
      const youtubeId = getYoutubeId(item.src);
      if (youtubeId) {
        const thumbUrl = `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`;
        return (
          <div className={styles['video-thumb-container']}>
            <img src={thumbUrl} alt={`Thumbnail ${index + 1}`} />
            <div className={styles['video-icon-overlay']}>
              <FaPlay size={12} color="#fff" />
            </div>
          </div>
        );
      } else {
        return (
          <div className={styles['video-thumb-placeholder']}>
            <FaPlay size={16} color="#fff" />
          </div>
        );
      }
    }
    return <img src={item.src} alt={`Thumbnail ${index + 1}`} />;
  };

  return (
    <div className={styles['SliderBlockContent']}>
      {items.map((_i, index) => (
        <div 
          className={classNames(styles['item-img'], {[styles.active]: index === indexFind})} 
          key={'img_' + index}
        >
          {renderSlideContent(_i, index)}
        </div>
      ))}

      {Boolean(prevSlide) && (
        <div 
          className={classNames(styles.nav_btn, styles.btn_left)} 
          onClick={() => setActive(prevSlide)}
        >
          <div className={styles['btn_icon']}>
            <MdOutlineKeyboardArrowLeft size={40}  />
          </div>
        </div>
      )}

      {Boolean(nextSlide) && (
        <div 
          className={classNames(styles.nav_btn, styles.btn_right)} 
          onClick={() => setActive(nextSlide)}
        >
          <div className={styles['btn_icon']}>
            <MdOutlineKeyboardArrowRight size={40}  />
          </div>
        </div>
      )}

      {items.length > 1 && (
        <div className={styles['thumbnails-wrapper']}>
          <div className={styles['thumbnails-container']} ref={containerRef}>
            {items.map((item, index) => (
              <div 
                key={`thumb_${index}`}
                ref={index === indexFind ? activeThumbRef : null}
                className={classNames(styles.thumbnail, {
                  [styles['thumbnail-active']]: index === indexFind
                })}
                onClick={() => setActive(item)}
              >
                {renderThumbnailContent(item, index)}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default SliderBlockContent